import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { StyledFocusable } from './Focusable.styled';
export function Focusable(props) {
  var children = props.children,
    divProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledFocusable, _extends({
    tabIndex: 0
  }, divProps), React.Children.map(props.children, function (child) {
    return /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
      tabIndex: -1,
      className: child.props.className
    });
  }));
}